export enum DiplomatKeyType {
   PGP,
   SSH,
   SSL,
}
